import React, { useState, useEffect } from "react";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";
import "./governance.css";
import toast, { Toaster } from "react-hot-toast";
import { Link } from "react-router-dom";
import config from "../../config/config";
import DataTable from "react-data-table-component";
import { FaPlus } from "react-icons/fa6";
import { FaCheck, FaTimes } from "react-icons/fa";

export default function Governance() {
  // Sample data (you can replace with API data)
  const data = [
    {
      tokenName: "MintChain",
      address: "mrmntw...u5fm",
      owner: "Alice.eth",
      title: "Increase Staking Rewards",
      startDate: "2025-07-01 11:20:00 PM",
      endDate: "2025-09-01 11:20:00 PM",
      voting: "yes / No",
      voteCount: 100,
      result: "Approved",
    },
    {
      tokenName: "MetaVerseX",
      address: "mrmntw...u5fm",
      owner: "Dan.eth",
      title: "Increase Staking Rewards",
      startDate: "2025-07-01 11:20:00 PM",
      endDate: "2025-09-01 11:20:00 PM",
      voting: "yes / No",
      voteCount: 80,
      result: "Rejected",
    },
    {
      tokenName: "EcoStake",
      address: "mrmntw...u5fm",
      owner: "Carol.eth",
      title: "Increase Staking Rewards",
      startDate: "2025-07-01 11:20:00 PM",
      endDate: "2025-09-01 11:20:00 PM",
      voting: "yes / No",
      voteCount: 100,
      result: "Approved",
    },
    {
      tokenName: "BlockTrust",
      address: "mrmntw...u5fm",
      owner: "Bob.eth",
      title: "Increase Staking Rewards",
      startDate: "2025-07-01 11:20:00 PM",
      endDate: "2025-09-01 11:20:00 PM",
      voting: "Voted",
      voteCount: 90,
      result: "Pending",
    },
    {
      tokenName: "EcoStake",
      address: "mrmntw...u5fm",
      owner: "Carol.eth",
      title: "Increase Staking Rewards",
      startDate: "2025-07-01 11:20:00 PM",
      endDate: "2025-09-01 11:20:00 PM",
      voting: "yes / No",
      voteCount: 90,
      result: "Pending",
    },
    {
      tokenName: "MintChain",
      address: "mrmntw...u5fm",
      owner: "Alice.eth",
      title: "Increase Staking Rewards",
      startDate: "2025-07-01 11:20:00 PM",
      endDate: "2025-09-01 11:20:00 PM",
      voting: "yes / No",
      voteCount: 60,
      result: "Rejected",
    },
  ];

  // Column definitions
  const columns = [
    { name: "Token Name", selector: row => row.tokenName, sortable: true },
    { name: "Address", selector: row => row.address },
    { name: "Owner", width: "100px", selector: row => row.owner },
    { name: "Proposal Title", selector: row => row.title },
    { name: "Start Date", selector: row => row.startDate },
    { name: "End Date", selector: row => row.endDate },
    {
      name: "Voting", selector: row => row.voting,
      width: "180px",
      cell: row => (
        <div className="d-flex gap-3">
          <div className="d-flex align-items-center gap-2">
            <Button className="btnCheck btn-sm rounded-5 px-0 py-0 bg-light-success border-0">
              <FaCheck title="Voting enabled" fill="#10B981" size={12} />
            </Button>
            Yes
          </div>
          <div className="d-flex align-items-center gap-2">
            <Button className="btnClose btn-sm rounded-5 px-0 py-0 bg-light-danger border-0">
              <FaTimes title="Voting disabled" fill="#FE4F4F" size={12} />
            </Button> No
          </div>
        </div>
      ),
    },
    { name: "Vote count", width: "100px", selector: row => row.voteCount },
    {
      name: "Result",
      selector: row => row.result,
      cell: row => (
        <span
          style={{
            padding: "4px 10px",
            borderRadius: "10px",
            backgroundColor:
              row.result === "Approved"
                ? "#212f26"
                : row.result === "Rejected"
                  ? "#461623"
                  : "#2c2720",
            color:
              row.result === "Approved"
                ? "#28a745"
                : row.result === "Rejected"
                  ? "#dc3545"
                  : "#f0ad4e",
           fontWeight: "500",
          }}
        >
          {row.result}
        </span>
      ),
    },
  ];

  const customStyles = {
    table: {
      style: {
        backgroundColor: 'transparent', // White background
      },
    },
    header: {
      style: {
        backgroundColor: '#000', // Outer container
        minHeight: '56px',
      },
    },
    headRow: {
      style: {
        backgroundColor: '#fceeee', // Light red header row
        color: '#fff',
        fontWeight: '600',
      },
    },
    headCells: {
      style: {
        color: '#fff',
        fontSize: '14px',
        fontWeight: '600',
        paddingLeft: '16px',
        paddingRight: '16px',
      },
    },
    rows: {
      style: {
        minHeight: '48px',
        borderBottom: '1px solid #212529',
        backgroundColor: '#121212',
      },
    },
    
    cells: {
      style: {
        fontSize: '14px',
        paddingLeft: '16px',
        paddingRight: '16px',
        color: '#fff',
      },
    },
    pagination: {
      style: {
        backgroundColor: '#121212',
        borderTop: '1px solid #212529',
        padding: '8px',
      },
    },
  };

  return (
    <>
      <Toaster />
      <Header />
      <div className="bg-darkgrey">
        <section className="governance py-5 ">
          <Container>
            <Row>
              <Col lg={12}>
                <div>
                  <h2 className="text-white">Governance Proposal</h2>
                  <div className=" mt-5">
                    <Row>
                      <Col lg={4}>
                        <div className="mb-3">
                          <Form.Select aria-label="Default select example" className="w-auto">
                            <option>Active</option>
                            <option>Inactive</option>
                          </Form.Select>
                        </div>
                      </Col>
                      <Col lg={8}>
                        <div className="text-end mb-3">
                          <Button as={Link} to={`${config.baseUrl}createproposal`} variant="info" className="rounded-5 text-white fw-normal">
                            <FaPlus />  Create Proposal
                          </Button>
                        </div>
                      </Col>

                      <Col lg={12}>
                        <div className="darktheme">
                          <div className="table-responsive">
                            <DataTable
                              columns={columns}
                              data={data}
                              pagination
                              highlightOnHover
                              responsive
                              theme="dark" // Optional, default is light
                              customStyles={customStyles}
                              noDataComponent="No Data Found"
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </div>
      <Footer />
    </>
  );
}
